var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegramIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 0C3.54667 0 0 3.54667 0 7.91667C0 12.2867 3.54667 15.8333 7.91667 15.8333C12.2867 15.8333 15.8333 12.2867 15.8333 7.91667C15.8333 3.54667 12.2867 0 7.91667 0ZM11.59 5.38333C11.4712 6.63417 10.9567 9.67417 10.6954 11.0754C10.5846 11.6692 10.3629 11.8671 10.1571 11.8908C9.69792 11.9304 9.34958 11.59 8.90625 11.2971C8.20958 10.8379 7.81375 10.5529 7.14083 10.1096C6.35708 9.595 6.86375 9.31 7.315 8.85083C7.43375 8.73208 9.46042 6.8875 9.5 6.72125C9.5055 6.69607 9.50477 6.66993 9.49787 6.64509C9.49097 6.62026 9.47811 6.59749 9.46042 6.57875C9.41292 6.53917 9.34958 6.555 9.29417 6.56292C9.22292 6.57875 8.11458 7.315 5.95333 8.77167C5.63667 8.98542 5.35167 9.09625 5.09833 9.08833C4.81333 9.08042 4.275 8.93 3.87125 8.79542C3.3725 8.63708 2.98458 8.55 3.01625 8.27292C3.03208 8.13042 3.23 7.98792 3.60208 7.8375C5.91375 6.83208 7.44958 6.16708 8.2175 5.85042C10.4183 4.93208 10.8696 4.77375 11.1704 4.77375C11.2337 4.77375 11.3842 4.78958 11.4792 4.86875C11.5583 4.93208 11.5821 5.01917 11.59 5.0825C11.5821 5.13 11.5979 5.2725 11.59 5.38333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram-icon.0879e238cbe9ce6f33c663aaa9eebd16.svg";